import { Message } from "primereact/message";
import { classNames } from "primereact/utils";
import { REVISAO } from "../nova-obra.constants";
import { MensagensRevisaoCondicoes } from "../components/aviso-condicoes";
import styles from "./etapa-revisao.module.scss";
import { AvisoStatusCondicoes } from "./components/aviso-status-condicoes";
import { SecaoDadosObra } from "./components/secao-dados-obra";
import { SecaoDuracao } from "./components/secao-duracao";
import { SecaoTiposObra } from "./components/secao-tipos-obra";
import { SecaoEquipe } from "./components/secao-equipe";
import type { EtapaRevisaoViewModel } from "./types-etapa-revisao";

/**
 * Etapa 5 "Revisão" (HU 2543, Figma `11209:107`/`11209:397`): consolida as etapas 1–4 só para
 * leitura; "Editar" volta à etapa da seção sem perder dados. A gravação é do botão Criar Obra.
 */
export function EtapaRevisaoView({
  editarDadosObra,
  editarDuracao,
  editarTipos,
  editarEquipe,
}: EtapaRevisaoViewModel) {
  return (
    <div className={styles.body} data-testid="etapa-revisao">
      <header className={styles.header}>
        <h2 className={styles.title}>{REVISAO.title}</h2>
        <p className={styles.subtitle}>{REVISAO.subtitle}</p>
      </header>

      <Message
        severity="secondary"
        role="status"
        className={classNames("p-message-block", styles.avisoId)}
        data-testid="revisao-aviso-id"
        text={REVISAO.avisoId}
      />

      <AvisoStatusCondicoes />
      <MensagensRevisaoCondicoes />

      <SecaoDadosObra onEditar={editarDadosObra} />
      <SecaoDuracao onEditar={editarDuracao} />
      <SecaoTiposObra onEditar={editarTipos} />
      <SecaoEquipe onEditar={editarEquipe} />
    </div>
  );
}
